import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Routes, Route } from "react-router-dom"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import { AppContext } from "AppContext"
import NotFound from "NotFound"

const App = () => {
  return (
    <React.Fragment>
      <AppContext>
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <>
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    <VerticalLayout>{route.component}</VerticalLayout>
                  </Authmiddleware>
                }
                key={idx}
                exact={true}
              />
            </>
          ))}
          <Route
            path="*"
            element={
              <NonAuthLayout>
                <NotFound />
              </NonAuthLayout>
            }
          />
        </Routes>
      </AppContext>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
